import DeleteFacility from "./DeleteFacility";

export default DeleteFacility